import {ROUTES} from '@contentlab/config/routesConstants';
import openContentStudioPricingModal from '@contentlab/views/contentlab/pricing/contentStudioPricingModalUtils';
import AnalyticsService from '@/services/analytics/AnalyticsService';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';
import useNavigation from '@/hooks/use-navigation';

export const OPEN_PRICING_TYPE = {
  REDIRECT: 'REDIRECT',
  MODAL: 'MODAL',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type OpenPricingType =
  (typeof OPEN_PRICING_TYPE)[keyof typeof OPEN_PRICING_TYPE];

function useOpenPricing() {
  const {navigate} = useNavigation();

  return (
    openType: OpenPricingType,
    source: string,
    callbacks?: {
      onCancelCallback?: () => void;
      onSuccessCallback?: () => void;
    }
  ) => {
    AnalyticsService.createFlow(FLOW_NAMES.CONTENT_STUDIO.PRICING, {
      source,
      screen_presentation_id:
        AnalyticsService.getActiveScreenPresented().screen_presentation_id,
    });

    if (openType === OPEN_PRICING_TYPE.REDIRECT) {
      navigate(`${ROUTES.CONTENT_LAB}${ROUTES.CONTENT_LAB_PRICING}`);
    } else if (openType === OPEN_PRICING_TYPE.MODAL) {
      openContentStudioPricingModal(source, callbacks);
    }
  };
}

export default useOpenPricing;
